import { render, staticRenderFns } from "./CompanyRegistrationComplete.vue?vue&type=template&id=f6239c44&scoped=true&"
import script from "./CompanyRegistrationComplete.vue?vue&type=script&lang=js&"
export * from "./CompanyRegistrationComplete.vue?vue&type=script&lang=js&"
import style0 from "./CompanyRegistrationComplete.vue?vue&type=style&index=0&id=f6239c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6239c44",
  null
  
)

export default component.exports